import { Icon } from "../Icon.js";
import mail_order_default from "../static/mail-order.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconMailOrder.tsx
/* istanbul ignore file -- @preserve */
const IconMailOrder = ({ color, height, style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: mail_order_default,
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconMailOrder };